import actions from "./actions";

export default function countriesReducer(state = [], action: { type: string; payload: any; }): any {
    switch (action.type) {
        case actions.SET_DATA:
            return [...action.payload];
        default:
            return state
    }
}
